import { useItemPageContext } from "../../context";

const ObsComponent = () => {
  const { obs, setObs } = useItemPageContext();

  const handleObsChange = (event) => {
    setObs(event.target.value);
  };

  return (
    <div className="border-2 p-4 space-y-2 border-gray-100 overflow-hidden rounded-md shadow">
      <p className="text-lg font-bold">Observações</p>
      <textarea
        value={obs}
        onChange={handleObsChange}
        className="p-4 rounded-md bg-gray-200 w-full h-32 outline-none resize-none focus:ring-2 focus:ring-primary-500"
      />
    </div>
  );
};

export default ObsComponent;
